import { Tag } from "antd"

export const TagColors = Object.freeze({
  MAGENTA: 'magenta',
  RED: 'red',
  VOLCANO: 'volcano',
  ORANGE: 'orange',
  GOLD: 'gold',
  LIME: 'lime',
  GREEN: 'green',
  CYAN: 'cyan',
  BLUE: 'blue',
  GEEKBLUE: 'geekblue',
  PURPLE: 'purple',
})

const ColoredTag = ({ children, tagColor = TagColors.BLUE, fontSize = '14px', className = '', style = {} }) => {
  return (
    <Tag color={tagColor} style={style} className={className}>
      <span style={{ fontSize: fontSize }}>
        {children}
      </span>
    </Tag>
  )
}

export default ColoredTag